<template>
  <div :class='$style.container' id='about'>
    <lazy-image :class='$style.img' :src='require("../assets/about.jpg")' />
    <container :class='$style.content' num='05' title='关于冠鳌'>
      <div :class='$style.right'>
        <!-- <h1 :class='$style.h1'>中华绒螯蟹常穴居江、河、湖荡泥岸</h1> -->
        <p
          :class='$style.desc'
        >{{about}}</p>
      </div>
    </container>
  </div>
</template>

<script>
import Container from "./Container";
export default {
  name: "About",
  components: { Container },
  data() {
    return {
      about: ""
    };
  },
  mounted() {
    this.about = company.about;
  }
};
</script>

<style lang='scss' module>
@import "../tool";
@media screen and (max-width: 750px) {
  .container {
    flex-direction: column-reverse;
  }
  .img {
    margin-top: rem(20);
    width: 100% !important;
  }
  .content {
    margin: 0 !important;
  }
}
.container {
  display: flex;
}
.content {
  margin-left: 72px;
  flex: 1;
}
.img {
  height: 100%;
  width: 50%;
}
.h1 {
  font-size: 28px;
}
.desc {
  font-size: 16px;
  letter-spacing: 2px;
  text-align: left;
  text-align: justify;
}
</style>